<script>

	export default {
		name: 'anchorContent',
		props: {
			el: {
				type: String,
				default: "div"
			},
			anchor: String,
			title: String
		},
		inject: [
			'addAnchor',
			'removeAnchor',
			'scrollToAnchor'
		],
		data () {
			return {
				inview: null
			}
		},
		mounted () {
			const hash = this.$route.hash.replace('#', '')
			this.addAnchor(this.anchor, this)
			if(hash === this.anchor) {
				setTimeout(() => {
					this.scrollToAnchor(this.anchor)
					this.$router.replace({ hash: null })
				}, 1000)
			}
		},
		destroyed () {
			this.removeAnchor(this.anchor, this)
		},
		render () {
			return (
				<this.el>
					{this.$slots.default}
				</this.el>
			)
		}
	}

</script>



// WEBPACK FOOTER //
// src/components/AnchorNav/AnchorContent.vue